import { Button, Checkbox, CircularProgress, Tooltip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import styles from './CardRegister.module.css';
import chip from '../../../assets/images/card_chip.svg';
import x from '../../../assets/images/x.svg';
import tick from '../../../assets/images/tick.svg';
import simpleLogo from '../../../assets/images/simpleNew.png';
import { useSelector } from 'react-redux';
import Accordion from '../Accordion/Accordion';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import queries from '../../../api/queries/PaymentQueries';
import { useToasterLogic } from 'utils/useToasterLogic';
import ConfirmDialog from 'components/common/ConfirmDialog/ConfirmDialog';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Dialog, DialogContent, IconButton, Skeleton } from '@mui/material';
import { MdErrorOutline, MdOutlineClose, MdOutlineContentCopy } from 'react-icons/md';
import { errorToast } from 'components/common/Toast/Toast';
import { useTranslation } from 'react-i18next';

const CardRegister = () => {
  const user = useSelector((state) => state.nonPersistedReducers?.userSliceReducer?.currentUser);
  const shopId = useSelector((state) => state.nonPersistedReducers?.shopSliceReducer?.shopId);
  const [accepted, setAccepted] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [read, setRead] = useState({ privacy: false, recurring: false });
  const { successToast } = useToasterLogic();
  const queryClient = useQueryClient();
  const { t, i18n } = useTranslation();

  const { id } = useParams();
  const { search } = useLocation();
  const [redirect, setRedirect] = useState();
  const navigate = useNavigate();

  const addCard = useMutation({
    mutationFn: () => queries.registerCard({ shopId: shopId }),
    onSuccess: (data) => {
      // successToast('Sikeres kártya regisztráció!');
      if (data.data.paymentRedirectURL) {
        window.location.href = data.data.paymentRedirectURL;
      }
      queryClient.invalidateQueries(['cardRegistration']);
    },
    onError: () => {
      errorToast(t('subscription.cardRegister.unsuccessful'));
    }
  });
  const deleteCard = useMutation({
    mutationFn: () => queries.deleteRegistration({ shopId: user.ownedShops[0].id }),
    onSuccess: () => {
      successToast(t('subscription.cardRegister.successfulDelete'));
      setOpenDialog(false);
      queryClient.resetQueries(['cardRegistration']);
    },
    onError: () => {
      errorToast(t('subscription.cardRegister.unsuccessfulDelete'));
    }
  });
  const fetchCardRegister = useQuery({
    queryKey: ['cardRegistration'],
    queryFn: () => queries.getRegistration({ shopId: user.ownedShops[0].id }),
    initialData: {},
    retry: (failureCount, error) => (error.response.status === 404 ? false : true),
    refetchOnWindowFocus: false,
    enabled: user?.ownedShops?.length > 0,
    onError: (error) => {
      if (error?.response?.status === 404) {
        queryClient.setQueryData(['cardRegistration'], {});
      }
    },
    refetchInterval: (data) => (data?.data?.isCardRegistering === true ? 20000 : 100000000)
  });

  const fetchRecurringProperties = useQuery({
    queryKey: ['recurringProperties'],
    queryFn: () => queries.getRecurringProperties(),

    refetchOnWindowFocus: false,
    enabled: user?.ownedShops?.length > 0
  });

  const registerCard = () => {
    addCard.mutate();
  };
  const removeCard = () => {
    deleteCard.mutate();
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('hu-HU', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    });
  };

  const getExternalIdQuery = useQuery({
    queryKey: ['externalId'],
    queryFn: async () =>
      queries.getExternalCheckoutId(id, {
        r: new URLSearchParams(search).get('r'),
        s: encodeURIComponent(new URLSearchParams(search).get('s'))
      }),
    onSuccess: (data) => {
      if (data?.status == 'CONFIRMED' && data?.paymentType === 'RECURRING') {
        localStorage.setItem('cardRegInProgress', 'true');
      }
    },
    enabled: !!id,
    staleTime: Infinity,
    cacheTime: Infinity
  });

  useEffect(() => {
    if (id) {
      setRedirect(true);
    }
  }, [id]);

  return (
    <div className={styles.cardDataContainer}>
      <div className={styles.topContainer}>
        <div className={styles.cardWrapper}>
          <div
            className={styles.creditCard}
            style={{
              backgroundColor: fetchCardRegister?.data?.data?.tokens?.find(
                (token) => token?.isValid === true && token?.used === false
              )
                ? 'var(--primary-success)'
                : fetchCardRegister?.data?.data?.tokens?.length > 0 &&
                  !fetchCardRegister?.data?.data?.tokens?.find(
                    (token) => token?.isValid === true && token?.used === false
                  ) &&
                  !fetchCardRegister?.data?.data?.isCardRegistering
                ? 'var(--primary-background-secondary)'
                : fetchCardRegister?.data?.data?.tokens?.find((token) => token?.isValid === false) &&
                  fetchCardRegister?.data?.data?.isCardRegistering
                ? 'var(--primary-background-secondary)'
                : 'var(--primary-error)'
            }}>
            <img className={styles.chip} src={chip} alt='card_chip' width={90} />
            {fetchCardRegister?.data?.data?.tokens?.find(
              (token) => token?.isValid === true && token?.used === false
            ) ? (
              <img src={tick} alt='tick_sign' width={'100px'} />
            ) : fetchCardRegister?.data?.data?.tokens?.length > 0 &&
              !fetchCardRegister?.data?.data?.tokens?.find(
                (token) => token?.isValid === true && token?.used === false
              ) &&
              !fetchCardRegister?.data?.data?.isCardRegistering ? (
              <div className={styles.reregister_info}>
                <MdErrorOutline size={40} style={{ color: 'black' }} />
                <p>
                  <b>{t('subscription.cardRegister.noToken')}</b>
                </p>
              </div>
            ) : fetchCardRegister?.data?.data?.tokens?.find((token) => token?.isValid === false) &&
              fetchCardRegister?.data?.data?.isCardRegistering ? (
              <div className={styles.progressYellow}>
                <CircularProgress size={30} color={'var(--primary-background-primary)'} />
                <div>{t('subscription.cardRegister.inProgress')}</div>
              </div>
            ) : (
              <img src={x} alt='tick_sign' width={'100px'} />
            )}
          </div>
        </div>
        <div className={styles.acceptContainer}>
          {fetchCardRegister?.data?.data?.tokens?.length > 0 ? (
            <div className={styles.buttonWrapperDelete}>
              <Button
                width={200}
                className={styles.buttonDark}
                disabled={deleteCard.isPending || fetchCardRegister?.data?.data?.isCardRegistering}
                onClick={() => {
                  setOpenDialog(true);
                }}>
                {deleteCard.isPending ? <CircularProgress size={25} /> : t('subscription.cardRegister.deleteCard')}
              </Button>
              <img
                style={{ cursor: 'pointer' }}
                src={simpleLogo}
                alt='SimplePay_logo'
                width={110}
                height={30}
                onClick={() => {
                  i18n.language == 'hu'
                    ? window.open('https://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf')
                    : window.open('https://simplepartner.hu/PaymentService/Payment_information.pdf');
                }}
              />
            </div>
          ) : (
            <div className={styles.buttonWrapper}>
              {user?.ownedShops?.length > 0 && !addCard.isPending && user?.billingInfo ? (
                <Button
                  width={200}
                  className={styles.buttonDark}
                  disabled={
                    !read.recurring ||
                    !read.privacy ||
                    addCard?.isLoading ||
                    fetchCardRegister?.data?.data?.isCardRegistering
                  }
                  onClick={() => {
                    if (read.recurring && read.privacy) {
                      registerCard();
                      setAccepted(true);
                    } else {
                      setAccepted(false);
                    }
                  }}>
                  {addCard.isPending ? <CircularProgress size={24} /> : t('subscription.cardRegister.registerCard')}
                </Button>
              ) : (
                <Tooltip title={t('subscription.cardRegister.first')}>
                  <span>
                    <Button width={200} className={styles.buttonDark} disabled={true}>
                      {addCard.isPending ? <CircularProgress size={24} /> : t('subscription.cardRegister.registerCard')}
                    </Button>
                  </span>
                </Tooltip>
              )}
              <img
                style={{ cursor: 'pointer' }}
                src={simpleLogo}
                alt='SimplePay_logo'
                width={110}
                height={30}
                onClick={() => {
                  window.open('https://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf');
                }}
              />
            </div>
          )}
          {fetchCardRegister?.data?.data?.isCardRegistering === undefined ? (
            <>
              <div className={!accepted ? styles.checkboxRed : styles.checkbox}>
                <Checkbox
                  value={read.privacy}
                  style={{ color: 'var(--primary-background-primary)' }}
                  onChange={() => {
                    setRead({ ...read, privacy: !read.privacy });
                  }}></Checkbox>
                <span style={{ width: '100%', lineHeight: '1.5rem' }}>
                  {t('subscription.cardRegister.iAccept1')}
                  {t('subscription.cardRegister.iAccept2')}
                  <a href='https://simplepay.hu/adatkezelesi-tajekoztatok/' target='blank'>
                    <p style={{ textDecoration: 'underline', margin: 0, color: 'blue' }}>
                      https://simplepay.hu/adatkezelesi-tajekoztatok/
                    </p>
                  </a>
                </span>
              </div>{' '}
              <div className={!accepted ? styles.checkboxRed : styles.checkbox}>
                <Checkbox
                  value={read.recurring}
                  style={{ color: 'var(--primary-background-primary)' }}
                  onChange={() => {
                    setRead({ ...read, recurring: !read.recurring });
                  }}></Checkbox>
                <span style={{ width: '100%', lineHeight: '1.5rem' }}>
                  {t('subscription.cardRegister.recurringAccept')}
                </span>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>

      <div className={styles.accordion_container}>
        <Accordion title={t('subscription.cardRegister.tooltip')}>
          <div className={styles.details}>
            {t('subscription.cardRegister.recurring1')}
            <br />
            {t('subscription.cardRegister.recurring2')}
            <br />
            <br />
            {t('subscription.cardRegister.during') +
              fetchRecurringProperties?.data?.data?.tokenAmount +
              t('subscription.cardRegister.db') +
              fetchRecurringProperties?.data?.data?.validUntil?.slice(0, 3)?.join('. ') +
              t('subscription.cardRegister.validUntil') +
              fetchRecurringProperties?.data?.data?.tokenAmount +
              t('subscription.cardRegister.maxValue') +
              fetchRecurringProperties?.data?.data?.maxValue +
              t('subscription.cardRegister.maxValue2')}
          </div>
        </Accordion>
      </div>
      <Dialog open={redirect} onClose={() => {}}>
        <DialogContent>
          <div className={styles.container}>
            {getExternalIdQuery?.data?.data?.status === 'CONFIRMED' ||
            getExternalIdQuery?.data?.data?.status === 'SUCCESS' ? (
              <>
                <div style={{ textAlign: 'center' }}>
                  <div className={styles.iconWrapper}>
                    <svg className={styles.successCheck} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52 52'>
                      <circle className={styles.successCheckCircle} cx='26' cy='26' r='25' fill='none' />
                      <path className={styles.succcesCheckCheck} fill='none' d='M14.1 27.2l7.1 7.2 16.7-16.8' />
                    </svg>
                  </div>
                  <h1 className={styles.cardTitle}>{t('subscription.cardRegister.success')}</h1>
                </div>

                <div className={styles.orderDetails}>
                  <h2 className={styles.detailsTitle}>{t('subscription.cardRegister.inProgress!')}</h2>
                  <p className={styles.detailsMessage}>{t('subscription.cardRegister.fewMinutes')}</p>

                  <div className={styles.detailRow}>
                    <span className={styles.detailLabel}>{t('subscription.cardRegister.transactionId')}</span>
                    <span className={styles.detailValue}>{getExternalIdQuery?.data?.data?.externalId}</span>
                    <IconButton
                      className={styles.copyButton}
                      onClick={() => navigator?.clipboard?.writeText(getExternalIdQuery?.data?.data?.externalId)}>
                      <MdOutlineContentCopy />
                    </IconButton>
                  </div>
                </div>
              </>
            ) : getExternalIdQuery?.data?.data?.status === 'REJECTED' ? (
              <>
                <div style={{ textAlign: 'center' }}>
                  <div className={styles.iconWrapper}>
                    <MdOutlineClose style={{ background: '#E6332A', color: 'white', borderRadius: '50%' }} size={40} />
                  </div>
                  <h1 className={styles.cardTitle}>{t('subscription.cardRegister.unsuccessful!')}</h1>
                </div>

                <div className={styles.orderDetails}>
                  <h2 className={styles.detailsTitle}>{t('subscription.cardRegister.rejected')}</h2>
                  <p className={styles.detailsMessage}>{t('subscription.cardRegister.checkData')}</p>

                  <div className={styles.detailRow}>
                    <span className={styles.detailLabel}>{t('subscription.cardRegister.transactionId')}</span>
                    <span className={styles.detailValue}>{getExternalIdQuery?.data?.data?.externalId}</span>
                    <IconButton
                      className={styles.copyButton}
                      onClick={() => navigator?.clipboard?.writeText(getExternalIdQuery?.data?.data?.externalId)}>
                      <MdOutlineContentCopy />
                    </IconButton>
                  </div>
                </div>
              </>
            ) : getExternalIdQuery?.data?.data?.status === 'TIMEOUT' ? (
              <>
                <div style={{ textAlign: 'center' }}>
                  <div className={styles.iconWrapper}>
                    <MdOutlineClose style={{ background: '#E6332A', color: 'white', borderRadius: '50%' }} size={40} />
                  </div>
                  <h1 className={styles.cardTitle}>{t('subscription.cardRegister.unsuccessful!')}</h1>
                </div>

                <div className={styles.orderDetails}>
                  <h2 className={styles.detailsTitle}>{t('subscription.cardRegister.timeout')}</h2>
                  <p className={styles.detailsMessage}>{t('subscription.cardRegister.timeoutMessage')}</p>

                  <div className={styles.detailRow}>
                    <span className={styles.detailLabel}>{t('subscription.cardRegister.transactionId')}</span>
                    <span className={styles.detailValue}>{getExternalIdQuery?.data?.data?.externalId}</span>
                    <IconButton
                      className={styles.copyButton}
                      onClick={() => navigator?.clipboard?.writeText(getExternalIdQuery?.data?.data?.externalId)}>
                      <MdOutlineContentCopy />
                    </IconButton>
                  </div>
                </div>
              </>
            ) : getExternalIdQuery?.data?.data?.status === 'CANCELLED' ? (
              <>
                <div style={{ textAlign: 'center' }}>
                  <div className={styles.iconWrapper}>
                    <MdOutlineClose style={{ background: '#E6332A', color: 'white', borderRadius: '50%' }} size={40} />
                  </div>
                  <h1 className={styles.cardTitle}>{t('subscription.cardRegister.unsuccessful!')}</h1>
                </div>

                <div className={styles.orderDetails}>
                  <h2 className={styles.detailsTitle}>{t('subscription.cardRegister.cancelled')}</h2>
                  <p className={styles.detailsMessage}>{t('subscription.cardRegister.cancelledMessage')}</p>

                  <div className={styles.detailRow}>
                    {/* <span className={styles.detailLabel}>SimplePay tranzakció azonosító:</span>
                    <span className={styles.detailValue}>{getExternalIdQuery?.data?.data?.externalId}</span> 
                    <IconButton
                      className={styles.copyButton}
                      onClick={() => navigator?.clipboard?.writeText(getExternalIdQuery?.data?.data?.externalId)}>
                      <MdOutlineContentCopy />
                    </IconButton>*/}
                  </div>
                </div>
              </>
            ) : getExternalIdQuery?.isLoading ? (
              <>
                <div style={{ textAlign: 'center' }}>
                  <div className={styles.iconWrapper}>
                    <CircularProgress size={40} style={{ color: 'var(--primary-background-secondary)' }} />
                  </div>
                  <h1 className={styles.cardTitle}>{t('subscription.cardRegister.inProgress!')}</h1>
                  <p>
                    <b>{t('subscription.cardRegister.dontClose')}</b>
                  </p>
                </div>

                <div className={styles.orderDetails}>
                  <Skeleton style={{ height: '40px' }} />
                  <Skeleton style={{ height: '40px' }} />
                  <Skeleton style={{ height: '40px' }} />
                  <Skeleton style={{ height: '40px' }} />
                </div>
              </>
            ) : (
              <>
                <div style={{ textAlign: 'center' }}>
                  <div className={styles.iconWrapper}>
                    <MdOutlineClose style={{ background: '#E6332A', color: 'white', borderRadius: '50%' }} size={40} />
                  </div>
                  <h1 className={styles.cardTitle}>{t('subscription.cardRegister.error')}</h1>
                </div>

                <div className={styles.orderDetails}>
                  <h2 className={styles.detailsTitle}>{t('subscription.cardRegister.serverError')}</h2>
                  <p className={styles.detailsMessage}>{t('subscription.cardRegister.serverErrorMessage')}</p>
                </div>
              </>
            )}

            <div style={{ textAlign: 'center' }}>
              <button
                onClick={() => {
                  navigate(`/shops/${shopId}/administration/subscriptions`);
                  setRedirect(false);
                }}
                className={styles.homeButton}>
                {t('common.back')}
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <ConfirmDialog
        open={openDialog}
        title={t('subscription.cardRegister.sure')}
        functionButtonText={t('subscription.cardRegister.deleteCard')}
        functionButtonColor={'green'}
        closeButtonText={t('common.cancel')}
        onOk={() => {
          removeCard();
        }}
        onClose={() => {
          setOpenDialog(false);
        }}
        multipleButtons
      />
    </div>
  );
};

export default CardRegister;
